import { apiRequest, getResource, postQuery } from "../api/http";

export function getAnalytics(obj) {
  return postQuery("/api/analytics/get-analysis-for-media", obj, {
    select: (data) => data.analysis,
    fallback: [],
  });
}

/** Query string of a views period filter (see getMostViewedVideos). */
const periodParams = ({ period, start, end }) => {
  const params = new URLSearchParams({ period });
  if (period === "custom") {
    params.set("start", start);
    params.set("end", end);
  }
  return params;
};

/**
 * The 5 most viewed videos (database `unique_viewers`): `filter` is `{ period: "7d" | "30d" | "all" }`
 * or `{ period: "custom", start, end }` (YYYY-MM-DD). Resolves with
 * `{ period, start, end, complete, trackedSince, videos: [{ _id, title, thumbnail, isShort, views, totalViews }] }`,
 * `null` on failure.
 */
export function getMostViewedVideos(filter) {
  return getResource(`/api/admin/most-viewed-videos?${periodParams(filter)}`, {
    select: (data) => data,
    fallback: null,
  });
}

/**
 * Views per genre of a category ("movie" | "tvshow" | "podcast") from the database
 * `unique_viewers`, every genre of the category included, most viewed first.
 * `filter`: see getMostViewedVideos. Resolves with
 * `{ category, period, start, end, complete, trackedSince, list: [{ _id, name, count }] }`,
 * `null` on failure.
 */
export function getGenreViews(category, filter) {
  return getResource(`/api/analytics/genre-views/${category}?${periodParams(filter)}`, {
    select: (data) => data,
    fallback: null,
  });
}

// Store stats are admin only (dashboard, analytics).

/**
 * Store stats, same shape for both stores; rejects on failure:
 * `{ downloads: "100K+", downloadsCount, downloadsLast30Days, rating: "4.8", reviewsCount, activeDevicesCount }`.
 * Counts the backend cannot compute yet are `null`.
 */
export function getPlaystoreAnalytics() {
  return apiRequest("get", "/api/admin/getPlaystoreAnalytics", {
    rethrow: true,
  });
}

/** App Store stats, see `getPlaystoreAnalytics`. */
export function getAppstoreAnalytics() {
  return apiRequest("get", "/api/admin/getAppstoreAnalytics", {
    rethrow: true,
  });
}

/**
 * Store downloads per day (`range` 7 or 30, ending yesterday) or per month (`range` "all"),
 * same figures as the store cards (Android device acquisitions, iOS first-time downloads).
 * Resolves with `{ range, android, ios, syncing }` where each platform is
 * `{ from, to, lastDate, total, points: [{ period, value }] }`; `null` on failure.
 */
export function getStoreDownloads(range) {
  return getResource(`/api/admin/store-downloads?range=${range}`, {
    select: (data) => data,
    fallback: null,
  });
}
